<template>
  <div
    v-if="$page.props.off_canvas_elements[name]?.active"
    :class="$page.props.off_canvas_elements[name]?.fixed ? 'invisible' : ''"
    class="d-inline-block menu-icon cursor-pointer m-4"
    @click="$emit('toggle:off-canvas')"
  >
    <i class="fas fa-bars fa-2x" style="cursor: pointer"></i>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    name: { type: String, default: 'left' },
  },
  emit: ['toggle:off-canvas'],
  setup() {
    return {};
  },
};
</script>
